import * as XLSX from 'xlsx';

/**
 * Exports data to an Excel file
 * @param {Array} data - Array of objects to export
 * @param {string} fileName - Name of the file (without extension)
 * @param {string} sheetName - Name of the Excel sheet
 */
export const exportToExcel = (data, fileName = 'export', sheetName = 'Data') => {
    try {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        
        // Finalize filename
        const fullFileName = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
        
        XLSX.writeFile(wb, fullFileName);
    } catch (error) {
        console.error("Excel export failed:", error);
    }
};
